import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EventService} from "../../shared/services/event.service";
// import {MalihuScrollbarService} from "ngx-malihu-scrollbar";

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowComponent implements OnInit, OnChanges {

  @Input() title: string = '';
  @Input() background: string = '#FFFFFF';
  @Input() width: number = 900;
  @Input() height: number = 800;
  @Input() isCalendar: boolean = false;
  @Input() visible: boolean = false;
  @Input() scrollbar: boolean = true;
  @Input() type: string = 'window';

  @Output() close = new EventEmitter<boolean>();

  public bodyStyles = null;

  constructor(private eventService: EventService) {

  }

  ngOnInit() {
    this.bodyStyles = {
      'height': this.height + 'px',
      'min-height': this.height + 'px',
      'background-color': this.background
    };

    if (!this.scrollbar) {
      delete this.bodyStyles['height'];
      delete this.bodyStyles['min-height'];
    }

  }

  ngOnChanges(simple: SimpleChanges) {
    if (this.type == 'window') {
      if (simple.visible && simple.visible.currentValue) {
        this.eventService.disableBodyScrollbar.emit(false);
      }
    }
  }

  closeModalWindow() {
    this.visible = false;
    this.close.emit(this.visible);
    if (this.type == 'window') {
      this.eventService.disableBodyScrollbar.emit(true);
    }
  }

}
